import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, map, of, switchMap, take } from 'rxjs';
import { CropFieldNutrientCalculationsResponse } from 'src/app/bem/shared/models/models';
import { BemApiService } from 'src/app/bem/shared/services/bem-api.service';
import { selectCropYear } from 'src/app/store/selectors';

export const bemFieldAccessGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const bemApiService = inject(BemApiService);
  const store = inject(Store);
  const cropFieldParam = route.paramMap.get('cropfieldId');
  const cropFieldId = Number(cropFieldParam);

  if (cropFieldParam === null || cropFieldParam.trim() === '' || !Number.isInteger(cropFieldId)) {
    return router.createUrlTree(['/bem']);
  }

  return store.select(selectCropYear).pipe(
    take(1),
    switchMap((cropYear) => bemApiService.isBemCustomer(cropYear).pipe(
      switchMap(({ isBemCustomer }) => isBemCustomer
        ? bemApiService.getCropFieldNutrientCalculation(cropYear).pipe(
          map((cropFields: CropFieldNutrientCalculationsResponse[]) =>
            cropFields.some((field) => field.id === cropFieldId) ? true : router.createUrlTree(['/bem'])),
        )
        : of(router.createUrlTree(['/'])),
      ),
    )),
    catchError(() => of(router.createUrlTree(['/']))),
  );
};
